import { render, staticRenderFns } from "./EditCategoryTag.vue?vue&type=template&id=61c64af5&scoped=true&"
import script from "./EditCategoryTag.vue?vue&type=script&lang=js&"
export * from "./EditCategoryTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c64af5",
  null
  
)

export default component.exports